export function universalForm() {
    return {
        loading: false,
        responseMessage: '',
        isSuccess: false,
        form: {
            userName: '',
            userPhone: '',
            company: '',   // Додано поле компанії
            budget: '',    // Додано поле бюджету/послуги
            priority: '',  // Додано поле пріоритетності
            message: '',
        },
        errors: {},

        get hasErrors() {
            return Object.keys(this.errors).length > 0;
        },

        validate() {
            const errors = {};
            if (!this.form.userName || !this.form.userName.trim()) {
                errors.userName = "Введіть ваше ім'я";
            }
            if (!this.form.userPhone || !this.form.userPhone.trim()) {
                errors.userPhone = 'Введіть номер телефону';
            } else if (!/^[+\d\s()\-]{7,}$/.test(this.form.userPhone.trim())) {
                errors.userPhone = 'Вкажіть коректний номер (наприклад, +38 099 123 45 67)';
            }
            if (!this.form.message || !this.form.message.trim()) {
                errors.message = 'Опишіть задачу — кілька речень буде достатньо';
            }
            this.errors = errors;
            return Object.keys(errors).length === 0;
        },

        focusFirstError() {
            const firstField = Object.keys(this.errors)[0];
            if (!firstField) return;
            const el = this.$root.querySelector(`#${firstField}`);
            if (el) el.focus();
        },

        async submitForm() {
            if (!this.validate()) {
                this.responseMessage = '';
                this.$nextTick(() => this.focusFirstError());
                return;
            }

            this.loading = true;
            this.responseMessage = '';
            this.isSuccess = false;

            // Формуємо об'єкт для відправки на сервер з новими полями CHAMP
            const formObject = {
                "Ім'я": this.form.userName,
                "Телефон": this.form.userPhone,
                "Компанія": this.form.company || 'Не вказано',
                "Бюджет_або_послуга": this.form.budget || 'Не вказано',
                "Терміни": this.form.priority || 'Не вказано',
                "Повідомлення": this.form.message,
            };

            try {
                const response = await fetch(window.location.href, {
                    method: 'POST',
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formObject),
                });

                if (!response.ok) throw new Error('Server error');

                const data = await response.json();
                this.responseMessage = data.message || 'Дякуємо! Вашу заявку успішно надіслано.';
                this.isSuccess = true;

                // Очищаємо всі поля форми після успішної відправки
                this.form = {
                    userName: '',
                    userPhone: '',
                    company: '',
                    budget: '',
                    priority: '',
                    message: ''
                };
                this.errors = {};
            } catch (error) {
                this.responseMessage = 'Не вдалося надіслати заявку. Спробуйте ще раз або зателефонуйте нам.';
                this.isSuccess = false;
            } finally {
                this.loading = false;
            }
        }
    }
}

export function registerUniversalForm(Alpine) {
    Alpine.data('universalForm', universalForm);
}
